import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const FAQ = lazy(() => import("../pages/faq"));
const RaiseSupportTicket = lazy(() => import("../pages/raise-support-ticket"));
const Resources = lazy(() => import("../pages/resources"));
const TicketLists = lazy(() => import("../pages/TicketLists"));

export const HelpAndSupportRouter = [
  {
    path: "/help-and-support",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "faq",
        element: (
          <Suspense fallback={<Backdrop />}>
            <FAQ />
          </Suspense>
        ),
      },
      {
        path: "raise-support-ticket",
        element: (
          <Suspense fallback={<Backdrop />}>
            <RaiseSupportTicket />
          </Suspense>
        ),
      },
      {
        path: "ticket-lists",
        element: (
          <Suspense fallback={<Backdrop />}>
            <TicketLists />
          </Suspense>
        ),
      },
      {
        path: "resources",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Resources />
          </Suspense>
        ),
      },
    ],
  },
];
